import { CustomRouter } from './components';

export default function App() {
	return (
		<div>
			<CustomRouter />
		</div>
	);
}
